import { c as _c } from "react/compiler-runtime";
import { IcoSearch16 } from '@onefootprint/icons';
import type { ControlProps } from 'react-select';
import { components } from 'react-select';
const Control = t0 => {
  const $ = _c(7);
  let children;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
  } else {
    children = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <IcoSearch16 color="quaternary" />;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== children || $[5] !== props) {
    t2 = <div className="flex items-center w-full pl-4 border-b border-solid border-b-[var(--dropdown-border-color)]">{t1}<components.Control {...props}>{children}</components.Control></div>;
    $[4] = children;
    $[5] = props;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
export default Control;